import { JUSBRASIL_DOMAIN } from '../../constants'

export const SIGNUP_MODAL_SEGMENTS = ['person', 'lawsuit', 'other', 'unknown'] as const

export type SignupModalSegment = (typeof SIGNUP_MODAL_SEGMENTS)[number]

const PERSON_CPF_PATH_REGEX = /^\/nome\/[^/]+\/cpf-/
const PERSON_CNPJ_PATH_REGEX = /^\/nome\/[^/]+\/cnpj-/
const LAWSUIT_PATH_PREFIX = '/processos'

export interface DeriveSegmentInput {
  referer: string | null | undefined
}

export function isSignupModalSegment(value: unknown): value is SignupModalSegment {
  return typeof value === 'string' && (SIGNUP_MODAL_SEGMENTS as readonly string[]).includes(value)
}

export function deriveSignupModalSegment({ referer }: DeriveSegmentInput): SignupModalSegment {
  if (!referer) return 'unknown'

  let url: URL
  try {
    url = new URL(referer)
  } catch {
    return 'unknown'
  }

  const host = url.host.toLowerCase()
  if (host !== JUSBRASIL_DOMAIN && !host.endsWith(`.${JUSBRASIL_DOMAIN}`)) {
    return 'unknown'
  }

  const pathname = url.pathname.toLowerCase().replace(/\/$/, '')

  if (pathname === LAWSUIT_PATH_PREFIX || pathname.startsWith(`${LAWSUIT_PATH_PREFIX}/`)) {
    return 'lawsuit'
  }
  if (PERSON_CPF_PATH_REGEX.test(pathname) || PERSON_CNPJ_PATH_REGEX.test(pathname)) {
    return 'person'
  }
  if (pathname.length > 0) return 'other'
  return 'unknown'
}
